import { useNaverShopSearchQuery } from "../service/hooks/queries";

export const useIsConnected = (rootStore: any) => {
  const shopCd = rootStore.searchStore.getShopCd;
  const naverUniqueId = rootStore.searchStore.getNaverUniqueId;
  const { data: shopSearchData, isLoading } = useNaverShopSearchQuery(
    rootStore,
    {
      shopCd,
      page: 1,
      size: 5,
      includeNpayUnregistered: true,
    },
    { enabled: !!naverUniqueId }
  );

  const hasConnectableShops = shopSearchData?.data?.metadata?.hasConnectableShops;

  return {
    hasConnectableShops,
    isLoading,
  };
};
